import Configs from '@/Configs';

/**
 * SuperAdmin Agents module (ROI + Prompt library) under `/admin/agents`.
 */
export const AGENTS_ADMIN_CONFIG = {
  name: 'agents',
  icon: 'Robot',
  library: 'phosphor',
  routing: {
    root: {
      path: '/admin/agents',
      securityLevel: [Configs.securityLevelSuperAdmin],
    },
    roi: {
      path: '/admin/agents/roi',
      securityLevel: [Configs.securityLevelSuperAdmin],
    },
    prompts: {
      path: '/admin/agents/prompts',
      securityLevel: [Configs.securityLevelSuperAdmin],
    },
  },
} as const;
